import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  Page,
  Layout,
  FormLayout,
  Card,
  Loading,
  Text,
  TextField,
  Select,
  InlineError,
  Checkbox,
  InlineStack,
  Button,
  Toast,
  Icon,
  List,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { validate } from "email-validator";
import { useNavigate } from "react-router-dom";

const AddUser = forwardRef((props, ref) => {
  const [firstNameValue, setFirstNameValue] = useState("");
  const handleChangeFirstName = useCallback((newValue) => {
    setFirstNameValue(newValue);
    setFirstNameError("");
  }, []);
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameValue, setLastNameValue] = useState("");
  const handleChangeLastName = useCallback((newValue) => {
    setLastNameValue(newValue);
    setLastNameError("");
  }, []);
  const [lastNameError, setLastNameError] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const handleChangeEmail = useCallback((newValue) => {
    setEmailValue(newValue);
    setEmailError("");
  }, []);
  const [emailError, setEmailError] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const handleChangePassword = useCallback((newValue) => {
    setPasswordValue(newValue);
    setPasswordError("");
    setPasswordsError("");
  }, []);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const handleChangeConfirmPassword = useCallback((newValue) => {
    setConfirmPasswordValue(newValue);
    setConfirmPasswordError("");
    setPasswordsError("");
  }, []);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordsError, setPasswordsError] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const handleSelectChangeRole = useCallback((value) => {
    setSelectedRole(value);
    setRoleError("");
  }, []);
  const optionsRoles = [
    { label: "Super Admin", value: "1" },
    { label: "Custom", value: "0" },
    // { label: "Author", value: "3" },
    // { label: "Administrator", value: "2" },
  ];
  const [roleError, setRoleError] = useState("");
  const [item, setItem] = useState({
    dashboard: true,
    pagesView: true,
    pagesAdd: true,
    pagesEdit: true,
    pagesDelete: true,
    sectionsView: true,
    sectionsAdd: true,
    sectionsEdit: true,
    sectionsDelete: true,
    blogsView: true,
    blogsAdd: true,
    blogsEdit: true,
    blogsDelete: true,
    sectionsView: true,
    sectionsAdd: true,
    sectionsEdit: true,
    sectionsDelete: true,
    versionClone: true,
    versionPublish: true,
    uiText: true,
    navigation: true,
    crm: true,
    settings: true,
  });
  const handleChangeDashboard = (newValue) => {
    setItem({ ...item, dashboard: newValue });
  };
  const handleChangePagesView = (newValue) => {
    setItem({ ...item, pagesView: newValue });
  };
  const handleChangePagesAdd = (newValue) => {
    setItem({ ...item, pagesAdd: newValue });
  };
  const handleChangePagesEdit = (newValue) => {
    setItem({ ...item, pagesEdit: newValue });
  };
  const handleChangePagesDelete = (newValue) => {
    setItem({ ...item, pagesDelete: newValue });
  };

  const handleChangeSectionsView = (newValue) => {
    setItem({ ...item, sectionsView: newValue });
  };
  const handleChangeSectionsAdd = (newValue) => {
    setItem({ ...item, sectionsAdd: newValue });
  };
  const handleChangeSectionsEdit = (newValue) => {
    setItem({ ...item, sectionsEdit: newValue });
  };
  const handleChangeSectionsDelete = (newValue) => {
    setItem({ ...item, sectionsDelete: newValue });
  };

  const handleChangeBlogsView = (newValue) => {
    setItem({ ...item, blogsView: newValue });
  };
  const handleChangeBlogsAdd = (newValue) => {
    setItem({ ...item, blogsAdd: newValue });
  };
  const handleChangeBlogsEdit = (newValue) => {
    setItem({ ...item, blogsEdit: newValue });
  };
  const handleChangeBlogsDelete = (newValue) => {
    setItem({ ...item, blogsDelete: newValue });
  };
  const handleChangeVersionClone = (newValue) => {
    setItem({ ...item, versionClone: newValue });
  };
  const handleChangeVersionPublish = (newValue) => {
    setItem({ ...item, versionPublish: newValue });
  };
  const handleChangeUiText = (newValue) => {
    setItem({ ...item, uiText: newValue });
  };
  const handleChangeNavigation = (newValue) => {
    setItem({ ...item, navigation: newValue });
  };
  const handleChangeCrm = (newValue) => {
    setItem({ ...item, crm: newValue });
  };
  const handleChangeSettings = (newValue) => {
    setItem({ ...item, settings: newValue });
  };

  useImperativeHandle(ref, () => ({
    handleSave() {
      if (
        !emailValue ||
        !validate(emailValue.replace(/\s/g, "")) ||
        !firstNameValue ||
        !lastNameValue ||
        !passwordValue ||
        !confirmPasswordValue ||
        passwordValue !== confirmPasswordValue ||
        (passwordValue.length < 6 && confirmPasswordValue) ||
        selectedRole === ""
      ) {
        !validate(emailValue.replace(/\s/g, "")) &&
          setEmailError("Please use a valid email address");
        !firstNameValue && setFirstNameError("This field is required");
        !lastNameValue && setLastNameError("This field is required");
        !emailValue && setEmailError("This field is required");
        !passwordValue && setPasswordError("This field is required");
        selectedRole === "" && setRoleError("Please select a role");
        !confirmPasswordValue &&
          setConfirmPasswordError("This field is required");
        passwordValue !== confirmPasswordValue &&
          setPasswordsError("Passwords do not match");
        passwordValue.length < 6 &&
          confirmPasswordValue &&
          setPasswordsError("Passwords must be at least 6 characters");
      } else {
        props.handleSavingState();
        let permissionsArray = [];
        item.dashboard && permissionsArray.push("dashboard");
        item.pagesView && permissionsArray.push("view pages");
        item.pagesAdd && permissionsArray.push("create pages");
        item.pagesEdit && permissionsArray.push("edit pages");
        item.pagesDelete && permissionsArray.push("delete pages");
        item.blogsView && permissionsArray.push("view blogs");
        item.blogsAdd && permissionsArray.push("create blogs");
        item.blogsEdit && permissionsArray.push("edit blogs");
        item.blogsDelete && permissionsArray.push("delete blogs");
        item.sectionsView && permissionsArray.push("view sections");
        item.sectionsAdd && permissionsArray.push("create sections");
        item.sectionsEdit && permissionsArray.push("edit sections");
        item.sectionsDelete && permissionsArray.push("delete sections");
        item.versionClone && permissionsArray.push("clone versions");
        item.versionPublish && permissionsArray.push("publish versions");
        item.uiText && permissionsArray.push("ui text");
        item.navigation && permissionsArray.push("navigations");
        item.crm && permissionsArray.push("crm");
        item.settings && permissionsArray.push("settings");

        const bodyObj = {
          ...(firstNameValue && { first_name: firstNameValue }),
          ...(lastNameValue && { last_name: lastNameValue }),
          ...(emailValue && { email: emailValue.replace(/\s/g, "") }),
          ...(passwordValue && { password: passwordValue }),
          ...(confirmPasswordValue && {
            "confirm-password": confirmPasswordValue,
          }),
          ...(selectedRole !== "" && {
            role: selectedRole !== "0" ? selectedRole : "",
          }),
          is_active: 1,
          ...(selectedRole === "0" && { permissions: permissionsArray }),
        };
        axios
          .post("management/users", bodyObj)
          .then((res) => {
            props.handleChangeModalAndRefresh();
          })
          .catch((error) => {
            // Error
            if (error.response) {
              props.handleResetSaving();
              setPasswordError(
                <ul>
                  {error.response.data.errors.password.map((element, index) => {
                    return (
                      <div key={index}>
                        <h2>{element}</h2>
                      </div>
                    );
                  })}
                </ul>
              );
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
            console.log(error.config);
          });
      }
    },
  }));
  return (
    <FormLayout>
      <FormLayout.Group>
        <TextField
          label=" First Name"
          value={firstNameValue}
          onChange={handleChangeFirstName}
          error={firstNameError}
        />
        <TextField
          value={lastNameValue}
          onChange={handleChangeLastName}
          error={lastNameError}
          label="Last Name"
        />
      </FormLayout.Group>
      <FormLayout.Group>
        <TextField
          value={emailValue}
          onChange={handleChangeEmail}
          error={emailError}
          label="Email"
        />
      </FormLayout.Group>

      <FormLayout.Group>
        <TextField
          value={passwordValue}
          onChange={handleChangePassword}
          error={passwordError}
          label="Password"
        />
        <TextField
          value={confirmPasswordValue}
          onChange={handleChangeConfirmPassword}
          error={confirmPasswordError}
          label="Confirm Password"
        />
      </FormLayout.Group>
      <InlineError message={passwordsError} />
      <Select
        placeholder="Please select"
        options={optionsRoles}
        onChange={handleSelectChangeRole}
        value={selectedRole}
        error={roleError}
        label="Role"
      />
      {selectedRole === "0" && (
        <div style={{ marginTop: "3rem" }}>
          <FormLayout>
            <Text variant="headingXs" as="h6">
              DASHBOARD
            </Text>

            <Checkbox
              label="Dashboard"
              checked={item.dashboard}
              onChange={handleChangeDashboard}
            />
            <Text variant="headingXs" as="h6">
              PAGES
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="View"
                checked={item.pagesView}
                onChange={handleChangePagesView}
              />
              <Checkbox
                label="Add"
                checked={item.pagesAdd}
                onChange={handleChangePagesAdd}
              />
              <Checkbox
                label="Edit"
                checked={item.pagesEdit}
                onChange={handleChangePagesEdit}
              />
              <Checkbox
                label="Delete"
                checked={item.pagesDelete}
                onChange={handleChangePagesDelete}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              SECTIONS
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="View"
                checked={item.sectionsView}
                onChange={handleChangeSectionsView}
              />
              <Checkbox
                label="Add"
                checked={item.sectionsAdd}
                onChange={handleChangeSectionsAdd}
              />
              <Checkbox
                label="Edit"
                checked={item.sectionsEdit}
                onChange={handleChangeSectionsEdit}
              />
              <Checkbox
                label="Delete"
                checked={item.sectionsDelete}
                onChange={handleChangeSectionsDelete}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              BLOGS
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="View"
                checked={item.blogsView}
                onChange={handleChangeBlogsView}
              />
              <Checkbox
                label="Add"
                checked={item.blogsAdd}
                onChange={handleChangeBlogsAdd}
              />
              <Checkbox
                label="Edit"
                checked={item.blogsEdit}
                onChange={handleChangeBlogsEdit}
              />
              <Checkbox
                label="Delete"
                checked={item.blogsDelete}
                onChange={handleChangeBlogsDelete}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              VERSIONS
            </Text>
            <FormLayout.Group condensed>
              <Checkbox
                label="Clone"
                checked={item.versionClone}
                onChange={handleChangeVersionClone}
              />
              <Checkbox
                label="Publish"
                checked={item.versionPublish}
                onChange={handleChangeVersionPublish}
              />
            </FormLayout.Group>
            <Text variant="headingXs" as="h6">
              UI TEXT
            </Text>
            <Checkbox
              label="UI Text"
              checked={item.uiText}
              onChange={handleChangeUiText}
            />
            <Text variant="headingXs" as="h6">
              CRM
            </Text>
            <Checkbox
              label="CRM"
              checked={item.crm}
              onChange={handleChangeCrm}
            />
            <Text variant="headingXs" as="h6">
              NAVIGATION
            </Text>
            <Checkbox
              label="Navigation"
              checked={item.navigation}
              onChange={handleChangeNavigation}
            />
            <Text variant="headingXs" as="h6">
              SETTINGS
            </Text>
            <Checkbox
              label="Settings"
              checked={item.settings}
              onChange={handleChangeSettings}
            />
          </FormLayout>
        </div>
      )}
    </FormLayout>
  );
});

export default AddUser;
